export class SortDescription {
  constructor(
    public readonly field: string,
    public readonly name: string,
  ) { }
}
